import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { XIcon, PlusIcon } from 'lucide-react';
interface InviteRow {
  id: string;
  name: string;
  contact: string;
  role: string;
}
export function InviteFamilyPage() {
  const navigate = useNavigate();
  const [invites, setInvites] = useState<InviteRow[]>([{
    id: '1',
    name: '',
    contact: '',
    role: 'Adult Member'
  }, {
    id: '2',
    name: '',
    contact: '',
    role: 'Child Member'
  }, {
    id: '3',
    name: '',
    contact: '',
    role: 'Adult Member'
  }]);
  const addRow = () => {
    setInvites([...invites, {
      id: Date.now().toString(),
      name: '',
      contact: '',
      role: 'Adult Member'
    }]);
  };
  const removeRow = (id: string) => {
    setInvites(invites.filter(invite => invite.id !== id));
  };
  const updateRow = (id: string, field: keyof InviteRow, value: string) => {
    setInvites(invites.map(invite => invite.id === id ? {
      ...invite,
      [field]: value
    } : invite));
  };
  return <div className="min-h-screen bg-[#f8f8f8] flex flex-col items-center px-5 py-10 font-sans" data-id="element-4024">
      <div className="w-full max-w-md mx-auto flex flex-col flex-1" data-id="element-4025">
        {/* Avatars */}
        <div className="flex justify-center mb-6" data-id="element-4026">
          <div className="flex -space-x-4" data-id="element-4027">
            <div className="w-16 h-16 rounded-full bg-[#e0d8f0] border-4 border-[#f8f8f8] flex items-center justify-center text-2xl z-20" data-id="element-4028">
              👩
            </div>
            <div className="w-16 h-16 rounded-full bg-[#d0eef3] border-4 border-[#f8f8f8] flex items-center justify-center text-2xl z-10" data-id="element-4029">
              👦
            </div>
            <div className="w-16 h-16 rounded-full bg-[#fce8e8] border-4 border-[#f8f8f8] flex items-center justify-center text-2xl z-0" data-id="element-4030">
              👴
            </div>
          </div>
        </div>

        {/* Header */}
        <div className="text-center mb-8" data-id="element-4031">
          <h1 className="text-3xl font-bold text-[#1a0647] mb-3" data-id="element-4032">
            Get your household on the same page.
          </h1>
          <p className="text-gray-500 text-base" data-id="element-4033">
            Protection only works when everyone follows through. Add your family
            so Caveo can guide each person through their own setup.
          </p>
        </div>

        {/* Invite Rows */}
        <div className="space-y-4 mb-6" data-id="element-4034">
          {invites.map(invite => <div key={invite.id} className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm relative" data-id="element-4035">
              <button onClick={() => removeRow(invite.id)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Remove" data-id="element-4036">
                <XIcon size={18} data-id="element-4037" />
              </button>
              <div className="space-y-3 pr-6" data-id="element-4038">
                <input type="text" placeholder="Name" value={invite.name} onChange={e => updateRow(invite.id, 'name', e.target.value)} className="w-full bg-transparent border-b border-gray-200 pb-2 text-[#111111] placeholder-gray-400 focus:outline-none focus:border-[#8528e2] transition-colors text-base" data-id="element-4039" />
                <input type="text" placeholder="Email or phone number" value={invite.contact} onChange={e => updateRow(invite.id, 'contact', e.target.value)} className="w-full bg-transparent border-b border-gray-200 pb-2 text-[#111111] placeholder-gray-400 focus:outline-none focus:border-[#8528e2] transition-colors text-base" data-id="element-4040" />
                <select value={invite.role} onChange={e => updateRow(invite.id, 'role', e.target.value)} className="w-full bg-transparent border-b border-gray-200 pb-2 text-[#111111] focus:outline-none focus:border-[#8528e2] transition-colors text-base appearance-none" data-id="element-4041">
                  <option data-id="element-4042">Adult Member</option>
                  <option data-id="element-4043">Child Member</option>
                  <option data-id="element-4044">Super Guardian</option>
                </select>
              </div>
            </div>)}
        </div>

        {/* Add Another */}
        <button onClick={addRow} className="flex items-center gap-2 text-[#8528e2] font-semibold text-sm mb-auto hover:text-[#7322c4] transition-colors" data-id="element-4045">
          <PlusIcon size={16} data-id="element-4046" />
          Add another person
        </button>

        {/* Actions */}
        <div className="mt-10 space-y-3" data-id="element-4047">
          <button onClick={() => navigate('/deep-assessment')} className="w-full bg-[#8528e2] text-white font-bold py-4 rounded-xl hover:bg-[#7322c4] transition-colors shadow-md text-lg" data-id="element-4048">
            Send Invites Now
          </button>
          <button onClick={() => navigate('/deep-assessment')} className="w-full bg-transparent text-gray-500 font-semibold py-4 rounded-xl hover:bg-gray-100 transition-colors text-lg" data-id="element-4049">
            Skip for Now
          </button>
        </div>

        <p className="text-center text-sm text-gray-500 italic mt-6" data-id="element-4050">
          Each person gets their own personalized action plan. They control
          their own privacy.
        </p>
      </div>
    </div>;
}